import styled from '@emotion/styled'

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto 30px;
`

export const Options = styled.div`
  width: calc(100% - 40px);
  display: grid;
  grid-template-columns: 30% 40% 30%;
  column-gap: 20px;
`

export const DeleteOption = styled.div`
  padding-top: 12px;
  opacity: .8;

  &:hover {
    opacity: 1;
  }
`
